import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as SX from './sx';
import type { MostPopularTagProps as Props } from './types';
import { Label } from '@aibees/shared/components';

export const MostPopularTag = memo(({ className }: Props) => {
  return (
    <Label
      className={classnames('MostPopularTag', className)}
      sx={SX.root}
      variant="soft"
      color="primary"
      size="xsmall"
    >
      Most Popular
    </Label>
  );
});

MostPopularTag.displayName = 'MostPopularTag';
